<template>
    <v-overlay :value="overlay" :z-index="zIndex ? zIndex : 6">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>

<script>
export default {
    name: "LoadOverlay",
    props: ['overlay', 'zIndex'],
}
</script>

<style scoped></style>
